import {storage} from '../../firebase';
import { ASSETS_LOAD_START, ASSETS_LOAD_SUCCESS } from './types';

import {map, merge, pick} from 'lodash-es';
import Promise from 'bluebird';

export const listAssets = ( dir = '' ) => ( dispatch ) => {
	//get reference to the folder we want to list
	dispatch({
		type : ASSETS_LOAD_START
	});

	return storage.ref( dir )
	.listAll()
	.then( async (res) => {
		const items = await Promise.mapSeries( res.items, async (item) => {
			const downloadURL = await item.getDownloadURL();
			return merge( 
				pick( item, 'name', 'fullPath' ), 
				{
					downloadURL,
					dir
				} 
			);
		} )
		dispatch({
			type : ASSETS_LOAD_SUCCESS,
			payload : items
		});
	} )
	.catch( err => {
		dispatch({
			type : ASSETS_LOAD_SUCCESS,
			payload : err.message || err
		});
	})
}

export const uploadAsset = ( dir, file ) => ( dispatch ) => {
	//get reference to the folder we want to list
	dispatch({
		type : ASSETS_LOAD_START
	});

	console.log( file.name );

	return storage.ref( dir ).child( file.name ).put(file)
	.then(() => {
		return dispatch( listAssets( dir ) );
	})

}

export const deleteAsset = ( asset ) => ( dispatch ) => {
	//get reference to the folder we want to list
	// dispatch({
	// 	type : ASSETS_LOAD_START
	// });

	return storage.ref( asset.dir ).child( asset.name ).delete()
	.then(() => {
		return dispatch( listAssets( asset.dir ) );
	})

}

